"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shortTitleToCourse_1 = require("./shortTitleToCourse");
var findCoursesMissingFromCourseList_1 = require("./findCoursesMissingFromCourseList");
exports.requireAllCoursesFromMap = function (courses, requirementMap, ruleTitle) {
    var creditsRequired = Object.keys(requirementMap).reduce(function (total, k) { return requirementMap[k] + total; }, 0);
    return exports.requireSomeCoursesFromMap(courses, requirementMap, ruleTitle, creditsRequired);
};
exports.requireSomeCoursesFromMap = function (initialCourses, requirementMap, ruleTitle, creditsRequired) { return function (courses) {
    if (courses === void 0) { courses = initialCourses; }
    var requirementsList = Object.keys(requirementMap);
    var shortTitleToCourse = shortTitleToCourse_1.shortTitleToCourseFactory(courses);
    var missingCourseTitles = findCoursesMissingFromCourseList_1.default(courses, requirementsList);
    var issues = [];
    var creditCounter = 0;
    var coursesConsumed = shortTitleToCourse(requirementsList).filter(function (course) {
        if (creditCounter > creditsRequired) {
            return false;
        }
        creditCounter += requirementMap[course.course_title.toLowerCase()] || 0;
        return true;
    });
    var creditsFound = coursesConsumed.reduce(function (total, course) {
        return (requirementMap[course.course_title.toLowerCase()] || 0) + total;
    }, 0);
    var coursesNotConsumed = courses.filter(function (c) { return !coursesConsumed.find(function (consumedCourse) { return consumedCourse === c; }); });
    var pass = creditCounter >= creditsRequired;
    if (!pass) {
        issues = issues.concat([
            {
                ruleTitle: ruleTitle,
                error: 'not-enough-credits',
                credits: creditsFound,
                creditsRequired: creditsRequired,
                acceptableCourses: missingCourseTitles.map(function (t) {
                    return t.toLowerCase();
                })
            }
        ]);
    }
    return {
        pass: pass,
        ruleTitle: ruleTitle,
        creditsRequired: creditsRequired,
        creditsFound: creditsFound,
        coursesConsumed: coursesConsumed,
        coursesNotConsumed: coursesNotConsumed,
        issues: issues,
        subVerificationResults: []
    };
}; };
//# sourceMappingURL=requireCoursesFromMap.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/utils/requireCoursesFromMap.js
// module id = 42
// module chunks = 22